export default __webpack_public_path__ + "static/media/QR.69f8325c.png";